import React, { useEffect } from "react";
import "./Product.css";
import { useStateValue } from "./StateProvider";
import ReactGA from "react-ga4";
function Product({
  sellerId,
  id,
  title,
  price,
  rating,
  ratings,
  seller,
  image1_url,
  image2_url,
  image3_url,
  image4_url,
  image5_url,
  description1,
  description2,
  description3,
  description4,
  description5,
}) {
  // to pull data from datalayer
  const [{ basket }, dispatch] = useStateValue(); //  <== if we distructure the state to get the basket

  //const [state , dispatch ] = useStateValue();        // state is the state of the global store

  //console.log('Produc.js:::this is the basket >>> ', basket);

  // lets dispatch the items selected
  const addToBasket = (event) => {
    event.preventDefault();

    // dispatching the item into the data layer
    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        sellerId,
        id: basket?.length + 1,
        title: title,
        rating: rating,
        ratings: ratings,
        price: price,
        seller: seller,
        image1_url: image1_url,
        image2_url: image2_url,
        image3_url: image3_url,
        image4_url: image4_url,
        image5_url: image5_url,
        description1: description1,
        description2: description2,
        description3: description3,
        description4: description4,
        description5: description5,
      },
    });

    // Send a custom event
    ReactGA.event({
      category: "Basket category",
      action: `${basket.length} item(s) added to basket by user`,
      label: "Shopping Cart label", // optional
      value: 99, // optional, must be a number
      nonInteraction: true, // optional, true/false
      transport: "xhr", // optional, beacon/xhr/image
    });
  };
  return (
    // <div className="product">
    <div className="product">
      <img className="product_img " src={image1_url} alt="prd" />
      <div className="product_info" key={id}>
        {/* <h6>{sellerId}</h6> */}
        {title.length > 40 ? (
          <h6>
            {/* {title.length > 100 ? title.substring(0, 120) + "..." : title} */}
          </h6>
        ) : (
          <h6></h6>
          // <h6>{title} </h6>
        )}
        {/* <h6>{seller}</h6> */}
        <h6>{description1}</h6>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div className="product_rating">
            {Array(rating)
              .fill()
              .map((_, index) => {
                return (
                  <p key={index} className="star_color">
                    &#9733;
                  </p>
                );
              })}
          </div>
          <h6>{ratings} ratings</h6>
        </div>
        <div className="product_price">
          <small>$</small>
          <strong>{price}</strong>
        </div>
      </div>
      <div className="addToCartButtonContainer">
        <button className="addToCart" onClick={addToBasket}>
          Add to Cart now
        </button>
      </div>
    </div>
  );
}

export default Product;
